import { SCP } from 'ia-react-core/~/interfaces/SCP';
import React, { ReactNode, FC, useCallback, ComponentType } from 'react';

import { StyledStatusText, StyledIcon } from './StatusText.styles';

export interface StatusTextProps extends SCP<'span'> {
  children?: ReactNode;
  /** Icon class to display to the left of the message. */
  Icon: ComponentType;
  /** Color of the icon. */
  iconColor?: string;
  /** Size of the icon. */
  iconSize?: number;
  /** Top position of the icon. */
  iconTop?: number;
  /** Margin right of the icon. */
  iconMarginRight?: number;
  /** Margin left of the icon. */
  iconMarginLeft?: number;
  /** Margin right of the icon. */
  iconPosition?: 'left' | 'right';
  /** Align the text when wrapping. */
  alignWrappedText?: boolean;
}

const StatusText: FC<StatusTextProps> = ({
  children,
  Icon,
  iconColor,
  iconSize = 18,
  iconTop = 3,
  iconMarginRight,
  iconMarginLeft,
  alignWrappedText = false,
  iconPosition = 'left',
  ...props
}) => {
  const As: FC<{ color: string; size: number; top: number; marginRight: number; marginLeft: number }> = useCallback(({ color, top, size, marginRight, marginLeft, ...p }) => <Icon {...p} />, [Icon]);
  return (
    <StyledStatusText
      {...props}
      alignWrappedText={alignWrappedText}
    >
      {iconPosition === 'left' && (
        <StyledIcon
          as={As}
          color={iconColor}
          size={iconSize}
          top={iconTop}
          marginLeft={iconMarginLeft}
          marginRight={iconMarginRight ?? 6}
        />
      )}
      {children}
      {iconPosition === 'right' && (
        <StyledIcon
          as={As}
          color={iconColor}
          size={iconSize}
          top={iconTop}
          marginLeft={iconMarginLeft ?? 6}
          marginRight={iconMarginRight}
        />
      )}
    </StyledStatusText>
  );
};

export default StatusText;
